export default __webpack_public_path__ + "static/media/tax-icon.a6f52a01.svg";